export const radius = {
  none: 0,
  sm: 4,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 9999,
} as const;

export type RadiusToken = keyof typeof radius;

export default radius;
